import React from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import axios from "axios";
import * as Colors from "material-ui/styles/colors";
import DatePicker from 'material-ui/DatePicker';

var moment = require("moment");
let DateTimeFormat;
var areIntlLocalesSupported = require('intl-locales-supported');

if (areIntlLocalesSupported(['sr', 'sr-Latn-RS'])) {
  DateTimeFormat = global.Intl.DateTimeFormat;
} else {
  const IntlPolyfill = require('intl');
  DateTimeFormat = IntlPolyfill.DateTimeFormat;
  require('intl/locale-data/jsonp/sr');
  require('intl/locale-data/jsonp/sr-Latn-RS');
}


const muiTheme = getMuiTheme({
  palette: {
    textColor: Colors.darkBlack,
    primary1Color: Colors.lightGreen600,
    primary2Color: Colors.indigo700,
    accent1Color: Colors.lightGreen600,
    pickerHeaderColor: Colors.lightGreen600,
    alternateTextColor: Colors.white
  },
  appBar: {
    height: 45
  }
});

export default class Jelovnik extends React.Component {
  constructor(props) {
    super(props);
    this.state={obrociData:[]}
  }

  getJelovnik = (event,date) => {
    date = moment(date).format("YYYY-MM-DD");
    var query = "/Jelovnik/" + this.props.match.params.idfirme + "/" + date;
    axios.get(query).then(res => {
      const data = res.data.data;
      this.setState({ obrociData: data});
      console.log(data);
    });
  };

  render() {
    
    return (
      <div
        style={{
          marginTop: 0,
          marginBottom: 0,
          padding: 0,
          fontFamily: "Raleway",
          textAlign: "left",
          background: "#fff",
          color: "white",
          fontSize: "14px",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <MuiThemeProvider muiTheme={muiTheme}>
           <DatePicker  floatingLabelText="Odaberi dan" 
           DateTimeFormat={DateTimeFormat} 
           locale="sr-Latn-RS" 
           autoOk = {true} 
           cancelLabel={"Odustani"}   
           onChange={this.getJelovnik}
            />
        </MuiThemeProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Moduli/Jelovnik.js